<section class="transaction-workspace">
  <form class="filter-panel" (ngSubmit)="applyFilters()">
    <div class="filter-panel__search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input
        class="form-control"
        name="query"
        [(ngModel)]="filter.q"
        [placeholder]="'SEARCH_TRANSACTIONS' | translate"
      />
    </div>
    <details class="multi-filter">
      <summary>
        {{ filter.marketplace.length ? filter.marketplace.join(', ') : ('ALL_MARKETPLACES' | translate) }}
      </summary>
      <div class="multi-filter__menu">
        @for (value of facets.marketplaces; track value) {
          <label>
            <input
              type="checkbox"
              [checked]="filter.marketplace.includes(value)"
              (change)="toggleFilterValue(filter.marketplace, value, $any($event.target).checked)"
            />
            {{ value }}
          </label>
        }
      </div>
    </details>
    <details class="multi-filter">
      <summary>
        {{ filter.mappingStatus.length ? filter.mappingStatus.join(', ') : ('ALL_MAPPING_STATUSES' | translate) }}
      </summary>
      <div class="multi-filter__menu">
        @for (value of facets.mappingStatuses; track value) {
          <label>
            <input
              type="checkbox"
              [checked]="filter.mappingStatus.includes(value)"
              (change)="toggleFilterValue(filter.mappingStatus, value, $any($event.target).checked)"
            />
            {{ value }}
          </label>
        }
      </div>
    </details>
    <details class="multi-filter">
      <summary>{{ filter.currency.length ? filter.currency.join(', ') : ('ALL_CURRENCIES' | translate) }}</summary>
      <div class="multi-filter__menu">
        @for (value of facets.currencies; track value) {
          <label>
            <input
              type="checkbox"
              [checked]="filter.currency.includes(value)"
              (change)="toggleFilterValue(filter.currency, value, $any($event.target).checked)"
            />
            {{ value }}
          </label>
        }
      </div>
    </details>
    <input
      class="form-control"
      type="date"
      name="postedFrom"
      [(ngModel)]="filter.postedFrom"
      [title]="'FROM_DATE' | translate"
    />
    <input
      class="form-control"
      type="date"
      name="postedTo"
      [(ngModel)]="filter.postedTo"
      [title]="'TO_DATE' | translate"
    />
    <label class="filter-check"
      ><input type="checkbox" name="missing" [(ngModel)]="filter.missingMappingsOnly" />
      {{ 'MISSING_ONLY' | translate }}</label
    >
    <button class="btn btn-primary" type="submit"><i class="fa-solid fa-filter"></i> {{ 'FILTER' | translate }}</button>
    <button class="btn btn-outline-secondary" type="button" (click)="resetFilters()">{{ 'RESET' | translate }}</button>
  </form>

  @if (error) {
    <div class="alert alert-danger">{{ error | translate }}</div>
  }
  @if (commandResult) {
    <div class="alert" [ngClass]="commandResultClass()">
      <strong>{{ commandResult.command }}</strong>:
      @if (remapOutcome) {
        {{ commandResult.updated.length }} {{ 'REMAPPED_RESULT' | translate }}.
        @if (remapOutcome.mapped) {
          {{ remapOutcome.mapped }} {{ 'MAPPED_RESULT' | translate }}.
        }
        @if (remapOutcome.missingMappings) {
          {{ remapOutcome.missingMappings }}
          {{ (remapOutcome.missingMappings === 1 ? 'MISSING_MAPPING_RESULT' : 'MISSING_MAPPINGS_RESULT') | translate }}.
        }
        @if (remapOutcome.exceptions) {
          {{ remapOutcome.exceptions }}
          {{ (remapOutcome.exceptions === 1 ? 'MAPPING_EXCEPTION_RESULT' : 'MAPPING_EXCEPTIONS_RESULT') | translate }}.
        }
        @for (outcome of remapOutcome.other; track outcome.status) {
          {{ outcome.count }} {{ outcome.status }}.
        }
      } @else {
        {{ commandResult.updated.length }} {{ 'UPDATED' | translate }}.
      }
      @if (commandResult.rejected.length) {
        {{ commandResult.rejected.length }} {{ 'REJECTED' | translate }}.
      }
    </div>
  }

  <div class="table-card">
    <div class="table-toolbar">
      <div>
        <strong>{{ page.totalElements | number }}</strong> {{ 'TRANSACTIONS_LOWER' | translate }}
        @if (selectedIds.size) {
          <span class="selected-count">{{ selectedIds.size }} {{ 'SELECTED' | translate }}</span>
        }
      </div>
      <div class="command-buttons">
        <button
          class="btn btn-sm btn-outline-secondary"
          type="button"
          [disabled]="!selectedIds.size || commandRunning"
          (click)="runCommand('remap')"
        >
          <i class="fa-solid fa-rotate-left"></i> {{ 'REMAP' | translate }}
        </button>
        <button
          class="btn btn-sm btn-outline-warning"
          type="button"
          [disabled]="!selectedIds.size || commandRunning"
          (click)="runCommand('hold')"
        >
          <i class="fa-solid fa-pause"></i> {{ 'HOLD' | translate }}
        </button>
        <button
          class="btn btn-sm btn-outline-success"
          type="button"
          [disabled]="!selectedIds.size || commandRunning"
          (click)="runCommand('release')"
        >
          <i class="fa-solid fa-play"></i> {{ 'RELEASE' | translate }}
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table finance-table align-middle mb-0">
        <thead>
          <tr>
            <th class="check-column"><input type="checkbox" (change)="togglePage($any($event.target).checked)" /></th>
            <th>{{ 'POSTED_DATE' | translate }}</th>
            <th>{{ 'TRANSACTION' | translate }}</th>
            <th>{{ 'MARKETPLACE' | translate }}</th>
            <th>{{ 'AMOUNT' | translate }}</th>
            <th>{{ 'MAPPING' | translate }}</th>
            <th>{{ 'CUSTOMER_REVENUE' | translate }}</th>
            <th>{{ 'AMAZON_FEES' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading) {
            <tr>
              <td colspan="9" class="loading-cell">
                <span class="spinner-border spinner-border-sm"></span> {{ 'LOADING' | translate }}
              </td>
            </tr>
          } @else {
            @for (transaction of page.items; track trackTransaction($index, transaction)) {
              <tr [class.table-active]="detail?.summary?.id === transaction.id">
                <td>
                  <input
                    type="checkbox"
                    [checked]="isSelected(transaction.id)"
                    (change)="toggleSelection(transaction.id, $any($event.target).checked)"
                  />
                </td>
                <td>
                  <span class="date-primary">{{ transaction.postedDate | date: 'yyyy-MM-dd' }}</span
                  ><small>{{ transaction.postedDate | date: 'HH:mm' }}</small>
                </td>
                <td>
                  <button type="button" class="transaction-link" (click)="openDetail(transaction)">
                    {{ transaction.transactionType || '—' }}<small>{{ transaction.id }}</small>
                  </button>
                </td>
                <td>{{ transaction.marketplace || '—' }}</td>
                <td class="amount-cell">
                  {{ transaction.amount | number: '1.2-2' }} <small>{{ transaction.currency }}</small>
                </td>
                <td>
                  <span class="status-pill" [ngClass]="statusClass(transaction.mappingStatus)">{{
                    transaction.mappingStatus || '—'
                  }}</span>
                </td>
                <td>
                  <span class="status-pill" [ngClass]="statusClass(transaction.buyingSidePostingStatus)">{{
                    transaction.buyingSidePostingStatus || '—'
                  }}</span>
                </td>
                <td>
                  <span class="status-pill" [ngClass]="statusClass(transaction.sellingSidePostingStatus)">{{
                    transaction.sellingSidePostingStatus || '—'
                  }}</span>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="openDetail(transaction)"
                    [title]="'OPEN_DETAILS' | translate"
                  >
                    <i class="fa-solid fa-chevron-right"></i>
                  </button>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="9" class="empty-cell">{{ 'NO_MATCHING_TRANSACTIONS' | translate }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    <div class="pagination-bar">
      <span>{{ 'PAGE' | translate }} {{ page.page + 1 }} / {{ page.totalPages || 1 }}</span>
      <div>
        <button class="btn btn-sm btn-light" type="button" [disabled]="page.page === 0" (click)="changePage(-1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <button
          class="btn btn-sm btn-light"
          type="button"
          [disabled]="page.page + 1 >= page.totalPages"
          (click)="changePage(1)"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>

  @if (detailLoading || detail) {
    <div class="detail-backdrop" (click)="closeDetail()"></div>
    <aside class="detail-panel">
      @if (detailLoading && !detail) {
        <div class="detail-loading"><span class="spinner-border"></span></div>
      } @else if (detail) {
        <div class="detail-header">
          <div>
            <span class="eyebrow">{{ detail.summary.transactionType }}</span>
            <h2>{{ detail.summary.id }}</h2>
          </div>
          <button type="button" class="btn-close" (click)="closeDetail()"></button>
        </div>
        <div class="detail-summary">
          <div>
            <span>{{ 'MARKETPLACE' | translate }}</span
            ><strong>{{ detail.summary.marketplace || '—' }}</strong>
          </div>
          <div>
            <span>{{ 'AMOUNT' | translate }}</span
            ><strong>{{ detail.summary.amount | number: '1.2-2' }} {{ detail.summary.currency }}</strong>
          </div>
          <div>
            <span>{{ 'MAPPING' | translate }}</span
            ><strong class="status-pill" [ngClass]="statusClass(detail.summary.mappingStatus)">{{
              detail.summary.mappingStatus || '—'
            }}</strong>
          </div>
          <div>
            <span>{{ 'ERP_DATE' | translate }}</span
            ><strong>{{ detail.summary.targetErpTransactionDate || '—' }}</strong>
          </div>
        </div>
        @if (detail.summary.missingMappings.length) {
          <div class="detail-alert">
            <strong>{{ 'MISSING_MAPPINGS' | translate }}</strong>
            <div>
              @for (mapping of detail.summary.missingMappings; track mapping) {
                <code>{{ mapping }}</code>
              }
            </div>
          </div>
        }
        @if (detail.mappingException) {
          <div class="alert alert-danger">
            <pre>{{ detail.mappingException }}</pre>
          </div>
        }
        <div class="side-grid">
          <article>
            <span>{{ 'CUSTOMER_REVENUE' | translate }}</span
            ><strong class="status-pill" [ngClass]="statusClass(detail.customerRevenueSide.status)">{{
              detail.customerRevenueSide.status || '—'
            }}</strong
            ><small>{{ detail.customerRevenueSide.erpOrderIds.join(', ') || ('NO_ERP_DOCUMENT' | translate) }}</small>
          </article>
          <article>
            <span>{{ 'AMAZON_FEES' | translate }}</span
            ><strong class="status-pill" [ngClass]="statusClass(detail.amazonFeeCostSide.status)">{{
              detail.amazonFeeCostSide.status || '—'
            }}</strong
            ><small>{{ detail.amazonFeeCostSide.erpOrderIds.join(', ') || ('NO_ERP_DOCUMENT' | translate) }}</small>
          </article>
        </div>
        <section class="ai-explanation">
          <header>
            <div>
              <h3><i class="fa-solid fa-wand-magic-sparkles"></i> {{ 'AI_TRANSACTION_EXPLANATION' | translate }}</h3>
              <p>{{ 'AI_TRANSACTION_EXPLANATION_HELP' | translate }}</p>
            </div>
            <button
              class="btn btn-sm btn-primary"
              type="button"
              [disabled]="explanationLoading"
              (click)="generateExplanation()"
            >
              <span *ngIf="explanationLoading" class="spinner-border spinner-border-sm"></span>
              <i *ngIf="!explanationLoading" class="fa-solid fa-sparkles"></i>
              {{ (explanation ? 'REGENERATE_EXPLANATION' : 'GENERATE_EXPLANATION') | translate }}
            </button>
          </header>
          @if (explanationError) {
            <div class="alert alert-danger py-2 mb-0">{{ explanationError | translate }}</div>
          }
          @if (explanation) {
            <div class="ai-explanation__result">
              <span class="ai-disclaimer">{{ 'AI_GENERATED_CONTENT' | translate }}</span>
              <p>{{ explanation }}</p>
            </div>
          }
        </section>
        <div class="detail-actions">
          <button class="btn btn-outline-secondary" type="button" (click)="runCommand('remap', [detail.summary.id])">
            <i class="fa-solid fa-rotate-left"></i> {{ 'REMAP' | translate }}
          </button>
          <button class="btn btn-outline-warning" type="button" (click)="runCommand('hold', [detail.summary.id])">
            <i class="fa-solid fa-pause"></i> {{ 'HOLD' | translate }}
          </button>
          <button class="btn btn-outline-success" type="button" (click)="runCommand('release', [detail.summary.id])">
            <i class="fa-solid fa-play"></i> {{ 'RELEASE' | translate }}
          </button>
        </div>
        <details open>
          <summary>{{ 'NORMALIZED_ELEMENTS' | translate }}</summary>
          <pre>{{ detail.normalizedElements | json }}</pre>
        </details>
        <details>
          <summary>{{ 'CUSTOMER_REVENUE_TARGET' | translate }}</summary>
          <pre>{{ detail.customerRevenueSide.target | json }}</pre>
        </details>
        <details>
          <summary>{{ 'AMAZON_FEE_TARGET' | translate }}</summary>
          <pre>{{ detail.amazonFeeCostSide.target | json }}</pre>
        </details>
      }
    </aside>
  }
</section>
